<!-- ============ HERO ============ -->
  <section class="ga-hero">
    <div class="ga-wrap ga-hero-grid">
      <div class="ga-hero-content ga-reveal">
        <span class="ga-eyebrow"><span class="dot"></span> GCSE Admission Open 2026–27</span>
        <h1>Achieve Top Grades in Your <span>GCSE Exams</span></h1>
        <p class="ga-hero-tagline">
          Sit Sehyog Academy's GCSE Mock Tests, pinpoint exactly where your child needs to improve, and follow an exam-board-aligned revision plan built around real results.
        </p>
        <div class="ga-btn-row">
          <a href="https://zfrmz.in/CXWHedw5dEnsTL7d361m" class="ga-btn-primary">Apply for GCSE Course</a>
          <a href="https://www.sehyog.co.uk/freedemo" class="ga-btn-outline">Book a Free Demo <i class="ti ti-arrow-right"></i></a>
        </div>
        <div class="ga-stat-row">
          <div class="ga-stat-chip">
            <span class="ic"><i class="ti ti-users"></i></span>
            <span><span class="num">10000+</span><br><span class="lbl">Students Guided</span></span>
          </div>
          <div class="ga-stat-chip">
            <span class="ic"><i class="ti ti-books"></i></span>
            <span><span class="num">All Core</span><br><span class="lbl">GCSE Subjects</span></span>
          </div>
          <div class="ga-stat-chip">
            <span class="ic"><i class="ti ti-chart-bar"></i></span>
            <span><span class="num">100%</span><br><span class="lbl">Personalised Feedback</span></span>
          </div>
        </div>
      </div>
      <div class="ga-hero-image ga-reveal">
        <div class="frame">
          <img src="https://images.pexels.com/photos/32213217/pexels-photo-32213217.jpeg" alt="Student preparing for GCSE exams at Sehyog Academy">
        </div>
        <div class="ga-badge-float">
          <span class="ic"><i class="ti ti-certificate"></i></span>
          <span>
            <span class="t1">Trusted by 10K+</span><br>
            <span class="t2">Parents &amp; Students</span>
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ COURSES ============ -->
  <section class="ga-section">
    <div class="ga-wrap">
      <div class="ga-section-head">
        <span class="bar"></span>
        <span class="label">Our GCSE Courses</span>
      </div>
      <h2 class="ga-title">Pick the Path That Fits Your Child</h2>
      <p class="ga-sub">From regular diagnostic mock tests to an intensive pre-exam bootcamp — choose the GCSE programme that matches your child's needs.</p>

      <div class="ga-course-grid">
        <div class="ga-course-card ga-reveal">
          <div class="inner">
            <div class="ga-course-info">
              <span class="ga-course-tag">GCSE Mock Test</span>
              <h3>GCSE Mock Test Series</h3>
              <p class="desc">Realistic, exam-board-style mock papers with detailed mark schemes and a topic-by-topic breakdown of strengths and gaps.</p>
              <ul class="ga-subject-list">
                <li><i class="ti ti-math-symbols"></i> Maths</li>
                <li><i class="ti ti-atom-2"></i> Sciences</li>
                <li><i class="ti ti-book"></i> English</li>
                <li><i class="ti ti-world"></i> Humanities</li>
              </ul>
              <a href="https://zfrmz.in/CXWHedw5dEnsTL7d361m" class="ga-course-cta gold">Apply Now <i class="ti ti-arrow-right"></i></a>
            </div>
            <div class="ga-course-image">
              <img src="https://images.pexels.com/photos/7972967/pexels-photo-7972967.jpeg" alt="Student sitting a GCSE mock exam">
            </div>
          </div>
        </div>

        <div class="ga-course-card ga-reveal">
          <div class="inner">
            <div class="ga-course-info">
              <span class="ga-course-tag">GCSE Bootcamp</span>
              <h3>GCSE Bootcamp (Pre-Exam Intensive)</h3>
              <p class="desc">A focused revision intensive before exam season: full mock papers, exam technique workshops, and one-to-one feedback to close the gap fast.</p>
              <a [routerLink]="['/gcse-summer-bootcamp']" class="ga-course-cta">Book Now <i class="ti ti-arrow-right"></i></a>
            </div>
            <div class="ga-course-image">
              <img src="https://images.pexels.com/photos/7972526/pexels-photo-7972526.jpeg" alt="Students in a GCSE revision bootcamp">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ WHY CHOOSE US ============ -->
  <section class="ga-section alt">
    <div class="ga-wrap">
      <div class="ga-section-head">
        <span class="bar"></span>
        <span class="label">Why Sehyog Academy</span>
      </div>
      <h2 class="ga-title">Everything Your Child Needs for GCSE Success</h2>
      <p class="ga-sub">Expert teaching, a curriculum mapped to the exam boards, and detailed feedback so every student walks into results day with confidence.</p>

      <div class="ga-feature-grid">
        <div class="ga-feature-card ga-reveal">
          <span class="ic"><i class="ti ti-school"></i></span>
          <h3>Subject-Specialist Teachers</h3>
          <p>Tutors who know each GCSE exam board inside out — not just the subject, but exactly how it's examined.</p>
        </div>
        <div class="ga-feature-card ga-reveal">
          <span class="ic"><i class="ti ti-books"></i></span>
          <h3>Exam Board-Aligned Curriculum</h3>
          <p>Revision materials and mock papers built around AQA, Edexcel, and OCR specifications — not generic content.</p>
        </div>
        <div class="ga-feature-card ga-reveal">
          <span class="ic"><i class="ti ti-report-analytics"></i></span>
          <h3>Assessment &amp; Feedback</h3>
          <p>Every mock test comes with a detailed grade-boundary report, so you know exactly what to work on next.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ PROCESS / HOW IT WORKS ============ -->
  <section class="ga-section">
    <div class="ga-wrap">
      <div class="ga-section-head">
        <span class="bar"></span>
        <span class="label">How It Works</span>
      </div>
      <h2 class="ga-title">From Mock Test to Top Grades</h2>
      <p class="ga-sub">A clear, guided revision journey — built around real exam conditions and real results, not guesswork.</p>

      <div class="ga-process-grid">
        <div class="ga-process-step ga-reveal">
          <div class="num">01</div>
          <h4>Sit a GCSE Mock Test</h4>
          <p>Full-length, exam-board-style papers under realistic timed conditions.</p>
        </div>
        <div class="ga-process-step ga-reveal">
          <div class="num">02</div>
          <h4>Get Your Grade Report</h4>
          <p>A detailed breakdown of predicted grade boundaries and topic-level strengths and gaps.</p>
        </div>
        <div class="ga-process-step ga-reveal">
          <div class="num">03</div>
          <h4>Personalised Revision Plan</h4>
          <p>Targeted topic tests and revision sessions built around what the results actually show.</p>
        </div>
        <div class="ga-process-step ga-reveal">
          <div class="num">04</div>
          <h4>Exam Technique &amp; Support</h4>
          <p>Ongoing mentoring and exam-technique coaching right up to results day.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ TESTIMONIALS ============ -->
  <section class="ga-testimonial-section">
    <div class="ga-wrap">
      <div class="ga-testimonial-head">
        <div class="ga-section-head">
          <span class="bar"></span>
          <span class="label">Testimonials</span>
        </div>
        <h2>What <span>Parents</span> Say About Us</h2>
      </div>

      <div class="ga-t-grid">
        <div class="ga-t-card ga-reveal">
          <span class="quote-ic"><i class="ti ti-quote"></i></span>
          <p>The GCSE mock tests showed us exactly which topics my daughter needed to focus on before her real exams. The feedback reports made revision so much more targeted than just working through textbooks blindly.</p>
          <div class="ga-t-foot">
            <span class="ga-avatar">PS</span>
            <span><span class="ga-t-name">Placeholder Testimonial</span><br><span class="ga-t-role">Parent</span></span>
          </div>
        </div>
        <div class="ga-t-card ga-reveal">
          <span class="quote-ic"><i class="ti ti-quote"></i></span>
          <p>My son went into his GCSE Maths and Science papers feeling genuinely prepared. The mock papers matched the real exam format closely, and the tutors explained every mistake clearly.</p>
          <div class="ga-t-foot">
            <span class="ga-avatar">PS</span>
            <span><span class="ga-t-name">Placeholder Testimonial</span><br><span class="ga-t-role">Parent</span></span>
          </div>
        </div>
        <div class="ga-t-card ga-reveal">
          <span class="quote-ic"><i class="ti ti-quote"></i></span>
          <p>The bootcamp before exam season was exactly what my daughter needed — structured, intensive, and focused on the topics that actually came up on results day.</p>
          <div class="ga-t-foot">
            <span class="ga-avatar">PS</span>
            <span><span class="ga-t-name">Placeholder Testimonial</span><br><span class="ga-t-role">Parent</span></span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ CONTACT ============ -->
  <section class="ga-section">
    <div class="ga-wrap">
      <div class="ga-contact ga-reveal">
        <div class="ga-contact-info">
          <h2><span>Contact</span> Us</h2>
          <p class="sub">Have questions about GCSE admission? We're here to help.</p>
          <div class="ga-contact-list">
            <div class="row"><span class="ic"><i class="ti ti-phone"></i></span> (0)2039808244</div>
            <div class="row"><span class="ic"><i class="ti ti-mail"></i></span> support@sehyog.co.uk</div>
            <div class="row"><span class="ic"><i class="ti ti-brand-whatsapp"></i></span> +44 7464772331</div>
          </div>
        </div>
        <div class="ga-contact-image">
          <img src="https://images.pexels.com/photos/32526073/pexels-photo-32526073.jpeg" alt="Sehyog Academy customer support">
        </div>
      </div>
    </div>
  </section>